import {Component, createRef} from 'react';

import {SaveButton, DeleteButton, CancelButton} from '../../components/buttons';


import ApplicationHeader from './grants-application-header';

import GrantsApplicationPageContainer from './grants-application-page-container';
import GrantsApplicationSummary from './grants-summary/grants-summary';

import GrantsApplicationStateApproved from './grants-state/grants-state-approved';
import GrantsApplicationStatePending from './grants-state/grants-state-pending';
import GrantsApplicationStateRejected from './grants-state/grants-state-rejected'
import ApplicationApi from "../../lib/applications/application-api";

import GrantsApplicationDelete from './grants-application-delete';

import MediaQuery from 'react-responsive'

import Dropdown from '../../components/dropdowns/dropdown';
import StickyContainer from "../../components/layout/sticky-container";
import GrantsStatus from "./grants-state/grants-state";

export default class GrantsApplicationPage extends Component {
    constructor(props) {
        super(props);

        this.navbar = createRef(null);

        this.state = {
            selectedPage: 0,
            amends: null,
            sections: [],
            validation: [],
            showDelete: false,
            setShowErrors: () => {
            }
        }
    }

    componentDidMount() {
        this.setSections();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.loaded === false && this.props.loaded === true) {
            this.setCurrentPageFromCompletedSections();
        }
    }

    setAmends(amends) {
        this.setState({amends});
    }

    setShowDelete(s) {
        this.setState({showDelete: s});
    }

    allSectionsComplete() {
        return this.state.sections.length === this.props.completedSections.length;
    }

    setCurrentPageFromCompletedSections() {
        let lastCompleted = null;

        if (this.allSectionsComplete()) {
            return this.setState({selectedPage: this.state.sections.length});
        }

        this.state.sections.forEach((section, index) => {
            if (_.findIndex(this.props.completedSections, s => {
                return section.id === s;
            }) !== -1) {
                lastCompleted = index;
            }
        });


        if (lastCompleted !== null) {
            this.setState({selectedPage: lastCompleted + 1});
        }

    }

    setValidation(validation) {
        this.setState({validation});
    }

    setSections() {
        const sections = this.props.application?.grant_version.config?.sections !== undefined ? [...this.props.application.grant_version.config.sections] : [];

        this.setState({sections: sections}, () => {
        });
    }

    scrollListener() {
        const sticky = this.navbar.current.offsetTop;

    }

    saveClick() {
        this.props.onSave();
    }

    deleteClick() {
        new ApplicationApi().deleteApplication(this.props.application.id).then(() => {
            window.location.href = '/myeb/grants/applications';
        });
    }

    cancelClick() {
        window.location.href = '/myeb/grants/applications';
    }

    scrollToTop() {
        document.querySelector('.content').scrollTo({top: 0, behavior: 'smooth'})
    }

    setShowErrors(func) {
        this.setState({setShowErrors: func})
    }

    backClick() {
        if (this.state.selectedPage == 0) return;

        this.scrollToTop();

        this.setState(state => ({selectedPage: state.selectedPage - 1}));
    }

    nextClick() {
        if (this.state.selectedPage == this.state.sections.length) return;

        this.scrollToTop();
        const section = {...this.state.sections[this.state.selectedPage]}

        this.props.onSectionComplete(true, section.id);

        this.setState(state => ({selectedPage: state.selectedPage + 1}));
    }

    paginationClick(index) {
        if (this.state.validation.length > 0) {
            return this.state.setShowErrors();
        }

        this.setState({selectedPage: index})
    }

    getPage() {
        return this.state.sections[this.state.selectedPage];
    }

    statusRequiresSummaryPage() {

        return this.props.application.status !== 'in progress';
    }

    renderPage() {
        const onSummaryPage = this.onSummaryPage();

        if (onSummaryPage || this.statusRequiresSummaryPage()) {


            return <GrantsApplicationSummary selectedPage={this.state.selectedPage}
                                             onSubmit={this.props.onSubmit}
                                             application={this.props.application}
                                             sections={this.state.sections}
                                             getQuestionValue={this.props.getQuestionValue}
                                             backClick={this.backClick.bind(this)}
                                             getApplication={this.props.getApplication}
                                             setAmends={this.setAmends.bind(this)}/>
        }

        const data = this.getPage()

        return <GrantsApplicationPageContainer sections={this.state.sections}
                                               title={data?.name}
                                               subtitle={data?.description}
                                               data={data}
                                               application={this.props.application}
                                               getQuestionValue={this.props.getQuestionValue}
                                               handleQuestionChange={this.props.handleQuestionChange}
                                               selectedPage={this.state.selectedPage}
                                               onSectionComplete={this.props.onSectionComplete}
                                               backClick={this.backClick.bind(this)}
                                               nextClick={this.nextClick.bind(this)}
                                               saveClick={this.saveClick.bind(this)}
                                               setValidation={this.setValidation.bind(this)}
                                               setShowErrors={this.setShowErrors.bind(this)}/>
    }

    onSectionChange(e) {
        const {value} = e;

        this.paginationClick(value);
    }

    onSummaryPage() {
        return this.state.selectedPage + 1 > this.state.sections.length;
    }

    sectionComplete(sectionId) {
        return _.findIndex(this.props.completedSections, s => {
            return sectionId === s;
        }) !== -1;
    }

    render() {
        const sections = this.state.sections.map((section, index) => ({
            label: section.name,
            value: index,
        }));

        const section = this.state.sections[this.state.selectedPage];


        return (
            <>
                {this.state.showDelete && <GrantsApplicationDelete onConfirm={this.deleteClick.bind(this)}
                                                                   setPopup={this.setShowDelete.bind(this)}/>}

                <div className="state-pages grant-application">
                    {!this.statusRequiresSummaryPage() &&
                        <StickyContainer>
                            <div
                                className={`state-pages__top ${this.onSummaryPage() ? 'state-pages__top--summary' : ''}`}
                                ref={this.navbar}>
                                {!this.onSummaryPage() &&
                                    <>
                                        <MediaQuery maxWidth={568}>
                                            <div className="state-pages-number__pagination utils__row utils__gap--20">
                                                {this.state.selectedPage !== 0 && <div className="utils__row"
                                                                                       onClick={() => this.paginationClick(this.state.selectedPage - 1)}>
                                                    <img src="/assets/rightArrow.svg" style={{rotate: '180deg'}}/>
                                                </div>}
                                                <p>{this.state.selectedPage + 1} of {sections.length}</p>
                                                {(this.state.selectedPage < sections.length && this.sectionComplete(section.id)) &&
                                                    <div className="utils__row"
                                                         onClick={() => this.paginationClick(this.state.selectedPage + 1)}>
                                                        <img src="/assets/rightArrow.svg"/></div>}
                                            </div>
                                        </MediaQuery>

                                        <MediaQuery minWidth={569}>
                                            <div className="utils__row">
                                                Section: <div className="utils__row pagination__circles">
                                                {this.state.sections.map((section, index) => {

                                                    return <div
                                                        className={`pagination-circle ${this.sectionComplete(section.id) ? 'pagination-circle--success' : ''} ${this.state.validation && this.state.selectedPage + 1 == index ? 'pagination-circle--disabled' : ''} ${this.state.selectedPage == index ? 'pagination-circle--toggled' : ''}`}>
                                                        {index + 1}
                                                        {this.sectionComplete(section.id) &&
                                                            <span className="pagination-circle__tick">✓</span>}
                                                    </div>
                                                })}
                                            </div>
                                            </div>
                                        </MediaQuery>
                                    </>
                                }
                                {
                                    this.props.disableActions !== true &&
                                    <div className="state-pages-top__buttons">
                                        <SaveButton mobile={true} onClick={this.saveClick.bind(this)}/>
                                        <DeleteButton mobile={true} onClick={() => this.setShowDelete(true)}/>
                                        <CancelButton mobile={true} onClick={this.cancelClick.bind(this)}/>
                                    </div>
                                }
                            </div>
                        </StickyContainer>

                    }

                    <GrantsStatus application={this.props.application}/>

                    {this.state.sections.length > 0 && this.renderPage()}
                </div>
            </>
        )
    }
}
